// x-media-fullscreen-ck4.js

/*
CK4 only
Article fullscreen media (images and videos) sticky effect using image-center class.
This supports event page, but trying to deprecate that for CK5 version.
*/

export default function xMediaFullscreenCK4() {

  if (document.body.id !== "vrtx-structured-article" && document.body.id !== "vrtx-structured-event") {
    return;
  }

  const fullscreenMediaContainersAll = new Set();

  // Sticky effect requires figcaption, so starting with that
  document.querySelectorAll("figcaption").forEach(figcaption => {
    const figure = figcaption.closest("figure");
    if (figure.parentElement.classList.contains("image-center")) {
      fullscreenMediaContainersAll.add(figure);
    }
  });

  fullscreenMediaContainersAll.forEach(fullscreenMediaContainer => {
    // Media height = viewport height. Since img/video is set to 100vh.
    const mediaHeight = window.innerHeight;

    window.addEventListener("scroll", function () {
      // Get media top position.
      const fullscreenMediaContainerTop = fullscreenMediaContainer.getBoundingClientRect().top;

      // If media container is past viewport top but not further past than media height..
      if (fullscreenMediaContainerTop < 0 && fullscreenMediaContainerTop > -mediaHeight) {
        fullscreenMediaContainer.classList.add("sticky");
      }
      else {
        fullscreenMediaContainer.classList.remove("sticky");
      }
      // If media container is further past viewport top than media height..
      if (fullscreenMediaContainerTop <= -mediaHeight) {
        fullscreenMediaContainer.classList.add("scrolled-past");
      }
      else {
        fullscreenMediaContainer.classList.remove("scrolled-past");
      }
    });
  });
}
